import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface SkipForNowButtonProps {
  onSkip: () => void;
}

const SkipUploadButton = styled.a`
  text-decoration: none;
  color: #A2AAB3;
`;

const SkipForNowButton = ({ onSkip }: SkipForNowButtonProps) => {
  const { t } = useTranslation();

  return (
    <SkipUploadButton
      id="profile-picture-skip-upload-button"
      href="#"
      onClick={onSkip}
    >
      {t('skip_for_now')}
    </SkipUploadButton>
  );
};

export default SkipForNowButton;
